import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllActivitiesByStatus } from 'domain/usecases';

export class RemoteGetAllActivitiesByStatus
  implements GetAllActivitiesByStatus
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllActivitiesByStatus.Result>,
  ) {}

  async execute(
    params?: GetAllActivitiesByStatus.Params,
  ): Promise<GetAllActivitiesByStatus.Result> {
    const { page, length } = params;
    const urlParsed = `${this.url}/${page}/${length}`;
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(urlParsed, {
        entity: params.entity,
        course: params.course,
        semester: params.semester,
        curricularUnit: params.curricularUnit,
        groups: params.group,
        starts: params.starts,
        ends: params.ends,
        order: params.order,
        orderColumn: params.orderColumn,
        query: params.query,
        status: params.status.toString(),
      }),
      responseType: 'json',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
